import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import { notify } from '../../versa/msgbox.js';
import view from '../views/product-packagings.js';
import form from '../forms/product-packagings.js';
import * as types from '../types.js';

const product_packagings = function()
{
	let product_packagings_crud = crud.create({
		async loadBaseData()
		{
			await Promise.all([
				api.call(api.list_companies, this.queryAll()).then((data) => (data ? db.set('companies', data) : Promise.resolve())).catch((e) => notify(e?.message || e)),
				api.call(api.list_products, this.queryAll()).then((data) => (data ? db.set('products', data) : Promise.resolve())).catch((e) => notify(e?.message || e)),
				api.call(api.list_manufacturers, this.queryAll()).then((data) => (data ? db.set('manufacturers', data) : Promise.resolve())).catch((e) => notify(e?.message || e)),
				api.call(api.list_product_packagings, this.queryAll()).then((data) => (data ? db.set('product_packagings', data) : Promise.resolve())).catch((e) => notify(e?.message || e)),
			]);
		},
		async queryData(query)
		{
			return await api.call(api.list_product_packagings, query);
		},
		async loadRecord(id)
		{
			return await api.call(api.select_product_packaging, ...JSON.parse(id));
		},
		async saveRecord(data, old_data)
		{
			let _record = {
				product_id: Number(data.product_id),
				manufacturer_id: data.manufacturer_id !== undefined && data.manufacturer_id !== null && String(data.manufacturer_id).trim() !== ''
					? Number(data.manufacturer_id)
					: null,
				code: data.code,
				level: data.level,
				factor: Number(data.factor),
				tertiary_capacity: data.tertiary_capacity ? Number(data.tertiary_capacity) : null,
				gtin: data.gtin || null,
				qr_code: data.qr_code || null,
				is_default: data.is_default == '1',
				is_disabled: data.is_disabled == '1',
			};
			if (old_data)
				return await api.call(api.update_product_packaging, data.company_id, data.id, _record);
			return await api.call(api.insert_product_packaging, data.company_id, _record);
		},
	});

	let fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [types.datalist()], store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'id', label: 'ID', types: [types.number(0, 2)] },
		{ index: 3, field: 'product_id', label: 'Produto', types: [types.datalist()], store: 'products', labels: ['name'] },
		{ index: 4, field: 'manufacturer_id', label: 'Fabricante', types: [types.datalist()], store: 'manufacturers', labels: ['nick'] },
		{ index: 5, field: 'code', label: 'Código', types: [] },
		{ index: 6, field: 'level', label: 'Nível', types: [] },
		{ index: 7, field: 'factor', label: 'Fator', types: [types.number(0, 2)] },
		{ index: 8, field: 'tertiary_capacity', label: 'Cap. Terciária', types: [types.number(0, 2)] },
		{ index: 9, field: 'gtin', label: 'GTIN', types: [types.gtin()] },
		{ index: 10, field: 'is_default', label: 'Padrão', types: [types.opt_bool(), types.datalist()] },
		{ index: 11, field: 'is_disabled', label: 'Inativa', types: [types.opt_bool(), types.datalist()] },
	];

	product_packagings_crud.run(
		'product_packagings',
		'Embalagens',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs
	);
};

export default product_packagings;
